import React from "react";

import ReactDOM from "react-dom/client";

import { logger } from "@/utils/logger";
import { initSentry } from "@/utils/sentry";

import "bootstrap/dist/css/bootstrap.min.css";
import "./global.scss";

import "@fontsource/inter/400.css"; // Regular
import "@fontsource/inter/500.css"; // Medium
import "@fontsource/inter/600.css"; // SemiBold
import "@fontsource/inter/700.css"; // Bold

import App from "./App";

// Initialize Sentry BEFORE React app renders
initSentry();

// Handle chunk loading errors - common in development when webpack rebuilds
// Only auto-reload in development mode to avoid disrupting production users
const isDevelopment = process.env.NODE_ENV === "development";

if (isDevelopment) {
  globalThis.addEventListener("error", (event) => {
    const error = (event as ErrorEvent).error || (event as ErrorEvent).message;
    const errorString = error?.toString() || "";
    if (errorString.includes("Loading chunk") || errorString.includes("ChunkLoadError")) {
      // Chunk loading error detected - reload the page to fetch new chunks
      logger.warn("Chunk loading error detected. Reloading page in 1 second...", {
        error: errorString,
        context: "chunkLoadErrorHandler",
      });
      setTimeout(() => {
        globalThis.location.reload();
      }, 1000);
    }
  });

  // Handle unhandled promise rejections (chunk loading errors often appear here)
  globalThis.addEventListener("unhandledrejection", (event) => {
    const error = (event as PromiseRejectionEvent).reason;
    const errorString = error?.toString() || "";
    if (errorString.includes("Loading chunk") || errorString.includes("ChunkLoadError")) {
      // Chunk loading error detected - reload the page to fetch new chunks
      logger.warn(
        "Chunk loading error detected in promise rejection. Reloading page in 1 second...",
        {
          error: errorString,
          context: "chunkLoadErrorHandler",
        }
      );
      event.preventDefault(); // Prevent default error handling
      setTimeout(() => {
        globalThis.location.reload();
      }, 1000);
    }
  });
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

